import React from 'react';

import { Box } from '@tanium/react-box';
import styled from '@tanium/react-emotion-9';
import { ThemeFontWeights } from '@tanium/theme-data';

import { PillBaseProps } from '.';

export interface TooltipContentProps extends Pick<PillBaseProps, 'keyForValue' | 'children'> {}

const NoWrapText = styled('span')({
  whiteSpace: 'nowrap',
});

const TooltipContent = ({ keyForValue, children }: TooltipContentProps) => {
  const getKeyForValue = () => {
    let keyForValueContent = null;
    if (keyForValue) {
      keyForValueContent = (
        <Box as={NoWrapText} overflow="hidden">
          {keyForValue}:{' '}
        </Box>
      );
    }
    return keyForValueContent;
  };

  return (
    <>
      {getKeyForValue()}
      <Box as="span" fontWeight={keyForValue ? ThemeFontWeights.Bold : undefined}>
        {children}
      </Box>
    </>
  );
};
export default TooltipContent;
